/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Field_DescriptionInputs */

const en_agent_authorization_field_description = /** @type {(inputs: Agent_Authorization_Field_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const zh_agent_authorization_field_description = /** @type {(inputs: Agent_Authorization_Field_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目描述`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Agent_Authorization_Field_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_field_description = /** @type {((inputs?: Agent_Authorization_Field_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Field_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_field_description(inputs)
	return zh_agent_authorization_field_description(inputs)
});
export { agent_authorization_field_description as "agent.authorization.field.description" }